module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Triangle-c57b87f5144f72880b7d9d17f9559c8c.svg";